import { Button, Grid, Typography } from "@material-ui/core";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import React, { useState } from "react";
import { CreateVendor } from "../CreateVendor/CreateVendor";
import { DeleteVendor } from "../DeleteVendor/DeleteVendor";
import { EditVendor } from "../EditVendor/EditVendor";
import { useTableData } from "./customHooks/useTableData";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiDataGrid-row": {
				cursor: "pointer",
			},
			"& .MuiDataGrid-columnHeaderTitle, & .MuiTablePagination-caption": {
				fontWeight: "bold",
				fontSize: "12px",
			},
			"& .MuiDataGrid-columnHeaderTitleContainer": {
				padding: "0",
			},
			// '& .MuiButtonBase-root':{
			//   padding: "8px 0",
			// },
			"& .MuiDataGrid-cell--textLeft": {
				fontSize: "12px",
			},
		},
		relative: {
			position: "relative",
		},
		textfield: {
			margin: theme.spacing(2),
		},
		btnModal: {
			display: "flex",
			justifyContent: "flex-end",
		},
		dataTable: {
			padding: theme.spacing(1, 2),
		},
	}),
);

type Props = {
	isLoading: boolean;
	getVendorsFromAPI: Function;
};

export const TableVendors = ({ isLoading, getVendorsFromAPI }: Props) => {
	const [modalCreateVendor, setModalCreateVendor] = useState(false);
	const [modalEditDataVendor, setModalEditDataVendor] = useState(false);
	const [modalDeleteVendor, setModalDeleteVendor] = useState(false);

	const [vendorIdForEdit, setVendorIdForEdit] = useState<number | null>(null);
	const [vendorIdForDelete, setVendorIdForDelete] = useState<number | null>(
		null,
	);

	const classes = useStyles();

	const { rows, columns } = useTableData({
		setVendorIdForEdit,
		setModalEditDataVendor,
		setVendorIdForDelete,
		setModalDeleteVendor,
	});

	return (
		<Grid container justifyContent="center">
			<Grid item md={12} xs={12} style={{ padding: "0 15px" }}>
				<Typography
					variant="h5"
					style={{ margin: "20px 0 20px", fontWeight: 600 }}
				>
					Vendors Management
				</Typography>
			</Grid>
			<Grid
				container
				justifyContent="center"
				alignItems="center"
				className={classes.root}
			>
				<Grid
					item
					md={12}
					xs={12}
					style={{ padding: "0 15px" }}
					className={classes.relative}
				>
					<EditVendor
						show={modalEditDataVendor}
						vendorIdForEdit={vendorIdForEdit}
						onHide={(shouldUpdate: boolean) => {
							setModalEditDataVendor(false);
							setVendorIdForEdit(null);
							if (shouldUpdate) getVendorsFromAPI().then(() => {});
						}}
					/>
					<DeleteVendor
						show={modalDeleteVendor}
						vendorIdForDelete={vendorIdForDelete}
						onHide={(shouldUpdate: boolean) => {
							setModalDeleteVendor(false);
							if (shouldUpdate) getVendorsFromAPI().then(() => {});
						}}
					/>
					<CreateVendor
						show={modalCreateVendor}
						onHide={(shouldUpdate: boolean) => {
							setModalCreateVendor(false);
							if (shouldUpdate) getVendorsFromAPI().then(() => {});
						}}
					/>

					<div style={{ width: "100%", height: "60vh" }}>
						<DataGrid
							className={classes.dataTable}
							density={"compact"}
							loading={isLoading}
							rows={rows}
							columns={columns}
							pageSize={25}
							disableColumnMenu
							disableColumnFilter
							disableColumnSelector
							disableSelectionOnClick
						/>
					</div>
					<Grid container justifyContent="flex-end">
						<Grid item md={2} xs={12} className={classes.btnModal}>
							<Button
								variant="contained"
								color="primary"
								onClick={() => setModalCreateVendor(!modalCreateVendor)}
								fullWidth
								style={{ margin: "20px 0 20px" }}
							>
								New vendor
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};
